module.exports = __webpack_public_path__ + "media/src/public/img/operators-90c5081f5b6fff8b808d6a20238c8d5c.svg";